import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import propTypes from 'prop-types';
import Swal from 'sweetalert2';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { Link } from 'react-router-dom';
import { createFetch } from '../../utils';
import lang from '../../lang';
const { URL_PREFIX } = window;


class UserForm extends React.Component {
    constructor() {
        super();
        this.state = {
            form: {
                timezone: momentTz.tz.guess(),
                isActive: true,
            },
            errorMessage: {},
            loading: false,
            profileList: [],
            userLocked: false,
        };
        this.changeFormValue = this.changeFormValue.bind(this);
        this.cancel = this.cancel.bind(this);
        this.getUserDetail = this.getUserDetail.bind(this);
        this.save = this.save.bind(this);
        this.lock = this.lock.bind(this);
    }

    async componentWillMount() {
        this.setState({ loading: true });
        try {
            await Promise.all([
                this.getProfileList(),
                this.getUserDetail(),
            ]);
            this.setState({ loading: false });
        } catch (error) {
            Swal.fire({
                title: 'An error occured',
                text: error.message,
                type: 'error',
            });
            this.setState({ loading: false });
        }
    }

    async getUserDetail() {
        const { id } = this.props.match.params;
        const { user } = this.props;
        if (id) {
            const userDetail = await createFetch({
                path: `users/manage/detail/${id}`,
                accessToken: user.accessToken,
                body: null,
                method: 'GET',
            });
            if (userDetail.status === 200) {
                this.setState({
                    form: userDetail.record,
                    userLocked: userDetail.isLocked,
                });
            }
        }
    }

    async getProfileList() {
        const { user } = this.props;
        const profileList = await createFetch({
            path: 'users/profile/list?limit=100',
            method: 'GET',
            body: null,
            accessToken: user.accessToken,
        });
        if (profileList.status === 200) {
            this.setState({
                profileList: profileList.records,
            });
        }
    }

    changeFormValue = (e) => {
        const { form } = this.state;
        const { name, type, checked, value } = e.target;

        // When user is being inactivated
        if (name === "isActive" && form.isActive === true && checked === false) {
            Swal.fire({
            title: "Are you sure?",
            text: `Please confirm if you want to inactivate user "${form.username}".`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, inactivate",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    form[name] = false;
                    this.setState({ form });
                }
            });

            return;
        }

        form[name] = type === "checkbox" ? checked : value;
        this.setState({ form });
    };

    cancel() {
        if (this.props.history.length > 2) this.props.history.goBack();
        else this.props.history.push(`${URL_PREFIX}/app/users`);
    }

    async save(resetForm = false) {
        const { form } = this.state;
        const { id } = this.props.match.params;
        const { user } = this.props;
        const errorMessage = {};
        this.setState({ loading: true });
        try {
            delete form.UserProfile;
            const result = await createFetch({
                path: 'users/manage',
                method: id ? 'PATCH' : 'POST',
                accessToken: user.accessToken,
                body: {
                    ...form,
                    locales: 'en',
                },
            });
            if (result.status === 200) {
                if (resetForm === false) {
                    this.cancel();
                }
            } else if (result.status === 400 && result.validation) {
                result.validation.forEach((validation) => {
                    errorMessage[validation.param] = lang.serverMessage[validation.msg] || validation.msg;
                });
            }
            this.setState({ loading: false, errorMessage });
        } catch (error) {
            this.setState({ loading: false });
            error.response.validation.forEach((validation) => {
                errorMessage[validation.param] = lang.serverMessage[validation.msg] || validation.msg;
            });
            this.setState({ errorMessage });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    async lock() {
        const { loading, userLocked } = this.state;
        const { id } = this.props.match.params;
        const { user } = this.props;
        if (loading) return;
        try {
            const result = await createFetch({
                path: 'users/manage/lock',
                method: 'POST',
                body: {
                    userId: id,
                    locked: !userLocked,
                },
                accessToken: user.accessToken,
            });
            if (result.status === 200) {
                this.setState({ loading: false, userLocked: !userLocked });
                Swal.fire({
                    title: lang.titleError,
                    text: `User ${userLocked ? 'unlocked' : 'locked for 60 min'}.`,
                    type: 'success',
                });
                return;
            }
            throw new Error(result.message);
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    render() {
        const {
            errorMessage, form, profileList, loading, userLocked,
        } = this.state;
        const { id } = this.props.match.params;
        return (
            <ReactModal
                isOpen
                onRequestClose={this.cancel}
                className="user-form"
                ariaHideApp={false}
            >
                <p className="text-center">
                    {loading ? <i className="fa fa-circle-notch fa-spin fa-4x loading" /> : null}
                </p>
                <h2>{id ? lang.users.editUser : lang.users.newUser}</h2>
                <h3>{lang.users.generalInformation}</h3>
                <div className="input-group">
                    <p>First Name</p>
                    <div>
                        <input type="text" className="form-control" value={form.firstName} name="firstName" onChange={this.changeFormValue} />
                        {errorMessage.firstName ? <p className="error-message">{errorMessage.firstName}</p> : null}
                    </div>
                </div>
                <div className="input-group">
                    <p>Last Name *</p>
                    <div>
                        <input type="text" className="form-control" value={form.lastName} name="lastName" onChange={this.changeFormValue} />
                        {errorMessage.lastName ? <p className="error-message">{errorMessage.lastName}</p> : null}
                    </div>
                </div>
                <div className="input-group">
                    <p>Username *</p>
                    <div>
                        <input type="text" className="form-control" value={form.username} name="username" onChange={this.changeFormValue} />
                        {errorMessage.username ? <p className="error-message">{errorMessage.username}</p> : null}
                    </div>
                </div>
                <div className="input-group">
                    <p>Phone Number</p>
                    <div>
                        <input type="text" className="form-control" value={form.phoneNumber} name="phoneNumber" onChange={this.changeFormValue} />
                        {errorMessage.phoneNumber ? <p className="error-message">{errorMessage.phoneNumber}</p> : null}
                    </div>
                </div>

                <div className="input-group">
                    <p>Email *</p>
                    <div>
                        <input type="text" className="form-control" value={form.email} name="email" onChange={this.changeFormValue} />
                        {errorMessage.email ? <p className="error-message">{errorMessage.email}</p> : null}
                    </div>
                </div>

                <div className="input-group">
                    <p>Is Active</p>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <input
                            type="checkbox"
                            style={{
                                width: "16px",
                                height: "16px",
                                margin: 0,
                                cursor: "pointer",
                            }}
                            name="isActive"
                            disabled={!id}
                            checked={form.isActive}
                            onChange={this.changeFormValue}
                        />
                        {errorMessage.isActive ? (
                        <p className="error-message">{errorMessage.isActive}</p>
                        ) : null}
                    </div>
                </div>

                <div className="input-group">
                    <p>Role</p>
                    <div>
                        <input type="text" className="form-control" value={form.role} name="role" onChange={this.changeFormValue} />
                        {errorMessage.role ? <p className="error-message">{errorMessage.role}</p> : null}
                    </div>
                </div>

                <div className="input-group">
                    <p>Gender</p>
                    <div>
                        <select className="form-control" value={form.gender} name="gender" onChange={this.changeFormValue} >
                            <option value={null} />
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                        </select>
                        {errorMessage.gender ? <p className="error-message">{errorMessage.gender}</p> : null}
                    </div>
                </div>

                <div className="input-group">
                    <p>Remarks</p>
                    <div>
                        <input type="text" className="form-control" value={form.remarks} name="remarks" onChange={this.changeFormValue} />
                        {errorMessage.remarks ? <p className="error-message">{errorMessage.remarks}</p> : null}
                    </div>
                </div>

                <h3>Authorization Setting</h3>
                <div className="input-group">
                    <p>Profile *</p>
                    <div>
                        <select className="form-control" value={form.profileId} onChange={this.changeFormValue} name="profileId">
                            <option value={null} />
                            {profileList.map(o => (
                                <option value={o.id}>{o.name}</option>
                            ))}
                        </select>
                        {errorMessage.profileId ? <p className="error-message">{errorMessage.profileId}</p> : null}
                    </div>
                </div>

                <h3>Locale Setting</h3>
                <div className="input-group">
                    <p>Timezone</p>
                    <div>
                        <select className="form-control" name="timezone" value={form.timezone} onChange={this.changeFormValue}>
                            <option value={null} />
                            {momentTz.tz.names().map(o => <option value={o}>{o}</option>)}
                        </select>
                        {errorMessage.profileId ? <p className="error-message">{errorMessage.profileId}</p> : null}
                    </div>
                </div>
                <div className="clearfix" />
                <p style={{ color: '#f00' }}>*) Required</p>
                <div className="action-btn">
                    <button disabled={loading} type="button" className="btn btn-primary " onClick={() => this.save()}>Save</button>
                    {id ? <button disabled={loading} type="button" className="btn btn-info" onClick={this.lock}>{userLocked ? 'Unlock' : 'Lock'}</button> : null }
                    <button disabled={loading} type="button" className="btn btn-warning" onClick={this.cancel}>Cancel</button>
                </div>
            </ReactModal>
        );
    }
}

UserForm.propTypes = {
    history: propTypes.object.isRequired,
    match: propTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
